import {SwipeableDrawer} from "@mui/material";
import {useModal} from "../../utils/modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock, faFire} from "@fortawesome/free-solid-svg-icons";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {TranslatedAttribute} from "../../../../utils";
import AllergenIcon from "../AllergenIcon";
import Puller from "./Puller";
import ProductForm from "../Products/ProductForm";

const LABEL_STYLES = {
  new: 'bg-green-100 text-green-800',
  star: 'bg-amber-100 text-amber-800',
  chefs_suggestion: 'bg-purple-100 text-purple-800',
};

const ProductDetailModal = () => {
  const modal = useModal();
  const {locale} = useSelector(state => state.app);
  const {t} = useTranslation();
  const {showProductOptions} = useSelector(state => state.app);
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false)
    // setTimeout(destroyModal, 1000)
  }

  useEffect(() => {
    setOpen(true)
  }, [])

  return (
    <>
      {
        <SwipeableDrawer
          BackdropProps={{style: {backgroundColor: 'rgba(159, 166, 144, 0.6)'}}}
          minFlingVelocity={250}
          PaperProps={{
            sx: {
              backgroundColor: "transparent",
              boxShadow: 'none'
            },
          }}
          anchor={'bottom'}
          open={open}
          onOpen={() => {
          }}
          onClose={close}
          transitionDuration={{exit: 600, appear: 0, enter: 600}}
          allowSwipeInChildren={true}
        >
          <Puller/>
          <div className={'max-md:w-full md:mx-10 mx-auto h-full rounded-t-[30px] p-4 relative bg-secondary'}>
            <div
              className={'overflow-scroll rounded-xl no-scrollbar max-h-[70dvh] flex flex-col justify-start items-center mt-10 relative'}>
              {
                modal.data.full_size_url ? (
                  <div className={'mb-4'}>
                    <img src={modal.data.full_size_url} alt="" className={'w-full max-w-fit rounded-xl'}/>
                  </div>
                ) : (
                  <></>
                )
              }

              <div className={'flex flex-row my-2'}>
                {
                  (modal.data.ingredient_tags).map((tag, idx) => {
                    return (
                      <AllergenIcon key={`${idx}-${tag}`} tag={tag}/>
                    )
                  })
                }
              </div>

              {modal.data.labels && modal.data.labels.length > 0 && (
                <div className={'flex flex-row flex-wrap gap-1 justify-center my-1'}>
                  {modal.data.labels.map((label) => (
                    <span key={label} className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${LABEL_STYLES[label] || 'bg-gray-100 text-gray-700'}`}>
                      {t(`labels.${label}`)}
                    </span>
                  ))}
                </div>
              )}
              {
                modal.data.note && (
                  <div className={'bg-blue-100 px-2 py-0.5 rounded-xl text-xs mb-2 w-fit mx-auto mt-2'}>
                    {t('general.note')}: {TranslatedAttribute(locale, modal.data, 'note')}
                  </div>
                )
              }

              <div className={'w-full items-center text-center'}>
                <div className={'text-[20pt]'}>{TranslatedAttribute(locale, modal.data, 'name')}</div>
                <div className={'font-normal text-[12px] mb-2'}>
                  {TranslatedAttribute(locale, modal.data, 'description')}
                </div>
                {modal.data.calorie && (
                  <div className={'flex flex-row items-center justify-center gap-1 text-[12px] text-orange-500 mb-2'}>
                    <FontAwesomeIcon icon={faFire} className={'text-orange-400'}/>
                    <span>{modal.data.calorie} {t('general.calorie')}</span>
                  </div>
                )}
                <>
                  {
                    <div>
                      {
                        showProductOptions &&
                        <ProductForm item={modal.data}/>
                      }
                      {
                        modal.data.preparation_time && (
                          <div
                            className={'text-center flex items-center justify-center bg-[#f8f8f8] rounded-xl mt-4'}>
                                                            <span
                                                              className={'m-2 text-sm'}>{modal.data.preparation_time} {t('general.minute')} </span>
                            <FontAwesomeIcon icon={faClock}
                                             className={'text-[#808080]'}/>
                          </div>
                        )
                      }

                    </div>
                  }

                </>
              </div>

            </div>
          </div>
        </SwipeableDrawer>
      }
    </>
  )
}

export default ProductDetailModal;
